module.exports = __webpack_public_path__ + "img/icon_touxiang_one@3x.54d463d0.png";